var scope_0 = require('/zeit/d4a394/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/zeit/d4a394/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51628ea3ddeae50ed98a554642cdfb64.js').default;
var scope_2 = require('/zeit/d4a394/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7bb980b9f8d283129560ce0be779b0b8.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    